import { render } from "./TheReminder.vue?vue&type=template&id=247496cf"
import script from "./TheReminder.vue?vue&type=script&lang=js"
export * from "./TheReminder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__